<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="headline">
					<span>Detail Transaksi</span>
					<span class="pl-2 font-weight-bold">{{ detailTransaction.trx_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">
								<v-icon color="primary">mdi-card-account-details</v-icon>
								<span class="ml-2">Detail Stockist</span>
							</div>
							<div class="pt-1">
								<span>{{detailTransaction.stockist_name}}</span>
								<span v-if="detailTransaction.stockist_code"> - {{detailTransaction.stockist_code}}</span>
							</div>
							<div class="pt-1">{{detailTransaction.stockist_mobilephone}}</div>
							<div class="pt-1">{{addressText(detailTransaction)}}</div>

							<div class="text-subtitle-1 font-weight-bold mt-1">
								<v-icon color="primary">mdi-account</v-icon>
								<span class="ml-2">Detail Pembeli</span>
							</div>
							<div class="pt-1">
								<span>{{detailTransaction.trx_buyer_name}}</span>
								<span v-if="detailTransaction.trx_buyer_sponsor_network_mid"> - {{detailTransaction.trx_buyer_sponsor_network_mid}}</span>
							</div>
							<div class="pt-1"><span v-if="detailTransaction.trx_buyer_mobilephone"> ({{detailTransaction.trx_buyer_mobilephone}})</span></div>
							<div class="pt-1">{{detailTransaction.trx_buyer_email}}</div>

							<div class="pt-1"></div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold mt-1">
								<v-icon color="primary">mdi-format-list-checkbox</v-icon>
								<span class="ml-2">Detail Transaksi</span>
							</div>
							<tbody>
								<tr>
									<td style="width:50%">Kode Transaksi</td>
									<td> : </td>
									<td>{{ detailTransaction.trx_code }}</td>
								</tr>
								<tr>
									<td >Waktu Transaksi</td>
									<td> : </td>
									<td>{{ detailTransaction.trx_datetime | tanggalid }}</td>
								</tr>
								<tr>
									<td >Status Transaksi</td>
									<td> : </td>
									<td>{{ detailTransaction.trx_status_name }}</td>
								</tr>
							</tbody>
						</v-col>
					</v-row>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table :headers="headers" :items="detailTransaction.product" hide-default-footer>
							<template v-slot:item.name="{ item }">
								<div>{{ item.name }}</div>
							</template>
							<template v-slot:item.code="{ item }">
								<div>{{ item.code }}</div>
							</template>
							<template v-slot:item.quantity="{ item }">
								<div>{{ item.quantity | toNumber }}</div>
							</template>
							<template v-slot:item.price_base="{ item }">
								<div>{{ item.price_base | toRupiah }}</div>
							</template>
							<template v-slot:item.price_total="{ item }">
								<div>{{ item.price_total | toRupiah }}</div>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="deep-purple lighten-5" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">status pemesanan</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-3">
						<v-col cols="4" md="4" class="py-0">
							<div class="rounded caption error text-uppercase white--text text-right pa-3">Transaksi Dibatalkan</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailTransaction.trx_cancel_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			headers: [
			{ text: 'Nama Produk', value: 'name', sortable: false},
			{ text: 'Kode Produk', value: 'code', sortable: false},
			{ text: 'Jumlah', value: 'quantity', sortable: false, align: 'center' },
			{ text: 'Harga', value: 'price_base', sortable: false, align: 'center' },
			{ text: 'Total Harga', value: 'price_total', sortable: false, align: 'center' },
			],
		}
	},
	computed:{
		...mapState('ecommerceTransaction', ['detailTransaction']),
	},
	methods :{
		showModal(){
			this.dialog = true
		},
		hideDialog(){
			this.dialog = false
		},
		addressText(value) {
			var data = []
			if (value.stockist_origin_address)
				data.push(value.stockist_origin_address)
			if (value.stockist_origin_subdistrict_name)
				data.push(value.stockist_origin_subdistrict_name)
			if (value.stockist_origin_city_name)
				data.push(value.stockist_origin_city_name)
			if (value.stockist_origin_province_name)
				data.push(value.stockist_origin_province_name)
			return data.join(', ')
		}
	}
}
</script>